"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonLink = void 0;
var React = __importStar(require("react"));
var Button_1 = __importDefault(require("../Button/Button"));
var Link_1 = __importDefault(require("../Link/Link"));
var styled_components_1 = __importDefault(require("styled-components"));
var ButtonLink = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, disabled = _a.disabled, _c = _a.external, external = _c === void 0 ? false : _c, _d = _a.linkClassName, linkClassName = _d === void 0 ? '' : _d, rel = _a.rel, target = _a.target, _e = _a.testid, testid = _e === void 0 ? 'buttonLink' : _e, url = _a.url, rest = __rest(_a, ["children", "className", "disabled", "external", "linkClassName", "rel", "target", "testid", "url"]);
    return (
    //@ts-ignore
    React.createElement(StyledButtonLink, { className: linkClassName, disabled: disabled, rel: rel, route: !external, target: target, testid: testid, to: url },
        React.createElement(Button_1.default, __assign({}, rest, { className: className, disabled: disabled }), children)));
};
exports.ButtonLink = ButtonLink;
exports.default = exports.ButtonLink;
var StyledButtonLink = (0, styled_components_1.default)(Link_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    && {\n        text-decoration: none;\n\n        &:hover {\n            text-decoration: none;\n        }\n    }\n"], ["\n    && {\n        text-decoration: none;\n\n        &:hover {\n            text-decoration: none;\n        }\n    }\n"])));
var templateObject_1;
